import React from "react";
import SEO from "../../components/SEO";
import Navbar from "../../components/Navbar";
import GetQuote from "./components/GetQuote";
import Footer from "../../components/Footer";

function QuotePage() {
  return (
    <>
      <SEO
        title="Get a Quote"
        description="Ready to build something? Submit your project brief to RastegHub. Tell us about your business, what you need, and your budget, we will get back to you within 24 hours."
        url="/quote"
      />
      <Navbar />
      <GetQuote />
      <Footer />
    </>
  );
}

export default QuotePage;
